import { useEffect, useState } from 'react';
import SolutionsDesktop from './SolutionsDesktop';
import SolutionsMobile from './SolutionsMobile';


export default function Solutions() {
  const [isDesktop, setIsDesktop] = useState(false);


  useEffect(() => {
    const checkWidth = () => setIsDesktop(window.innerWidth >= 1024);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  return isDesktop ? <SolutionsDesktop /> : <SolutionsMobile />;
}
